export const SUBJECT_TYPE = {
  PRODUCT: 'product',
}
